// Restricted (c) Siemens Healthineers AG, 2025, All rights reserved.

import { NgFor } from '@angular/common';
import {
  CUSTOM_ELEMENTS_SCHEMA,
  Component,
  Input,
  OnChanges,
} from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { SystemDetailsModel } from 'src/app/api/remote-api/.portal.generated/models';
import { NoDataIconComponent } from 'src/app/modules/shared/components/no-data-icon/no-data-icon.component';
import { TubeService } from 'src/app/modules/tube/services/tube.service';
import { APICallGateComponent } from '../../../shared/components/api-call-gate.component';
import { TubeCardComponent } from '../tube-card/tube-card.component';

@Component({
  selector: 'app-tube',
  templateUrl: './tube.component.html',
  styleUrls: ['./tube.component.scss'],
  standalone: true,

  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    APICallGateComponent,
    NgFor,
    TubeCardComponent,
    TranslateModule,
    NoDataIconComponent,
  ],
})
export class TubeComponent implements OnChanges {
  @Input({ required: true }) systemDetails!: SystemDetailsModel;

  // current system history
  history = this.tubeService.systemHistory;
  markers = this.tubeService.markers;

  constructor(private tubeService: TubeService) {}

  // execute in case any input changes (i.e. System details)
  ngOnChanges(): void {
    this.markers.request();
    this.history.request({
      systemSerialNumber: this.systemDetails.systemSerialNumber,
      systemMaterialNumber: this.systemDetails.systemMaterialNumber,
      ticketNumber: '-1', // TODO: make optional in API
    });
  }
}
